export async function createDefaultClientAndFarm({
  dispatch,
  tenantInputs,
  createClientAction,
  createFarmAction,
  editTenantPreferencesAction,
}) {
  const { streetAddress, postalCode, email } = tenantInputs

  const clientResponse = await dispatch(
    createClientAction({
      name: 'Default_Client',
      streetAddress,
      postalCode,
      email,
    }),
  )

  const clientId = clientResponse?.data?.id
  const tenantId = clientResponse?.data?.tenantId
  if (!clientId || !tenantId) {
    throw new Error('Unable to create default client for onboarding')
  }

  const farmResponse = await dispatch(
    createFarmAction({
      name: 'Default_Farm',
      streetAddress,
      postalCode,
      clientId,
      tenantId,
    }),
  )

  const farmId = farmResponse?.data?.id
  if (!farmId) {
    throw new Error('Unable to create default farm for onboarding')
  }

  await dispatch(
    editTenantPreferencesAction({
      path: 'cff.client',
      value: clientId,
    }),
  )
  await dispatch(
    editTenantPreferencesAction({
      path: 'cff.farms',
      value: [farmId],
    }),
  )
}
